import { PetVaccine } from '@app/services/graphql.service';

export interface ParsedPetVaccine
  // Remove the `__typename` to avoid type check between `Pet` and `PetWithStatus`.
  extends Omit<PetVaccine, '__typename'> {
  // #region -> Custom Flags <-
  // ----------

  vaccinationExpirationState?: VaccineStatusEnum;

  // ----------
  // #endregion

  // ///////////////////////////
}

/**
 * An enum that describes vaccination Status, used in camper-tile
 */
export enum VaccineStatusEnum {
  UpToDate = 0,
  ExpiringSoon = 1,
  Expired = 2,
}
